// extracted by mini-css-extract-plugin
export default {"leftDrawerCell":"eK_eL"};